module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('simplert2'), _vm._v(" "), _c('chat', {
    ref: "charbot",
    attrs: {
      "showbot": _vm.bots
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d06b7e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 999
// module chunks = 1